/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e990a01e1f886ae319272b03d75a687b>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TextHeadingFiveIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "TextHeadingFiveIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var _default = exports.default = TextHeadingFiveIcon;